import { lcmApiClient } from "lcm-iot-commons";
import { extractClientApplication } from "../extractors/clientApplicationExtractor";

/* istanbul ignore next */
export async function loadClientApplication(
  id: $TSFixMe,
  parameters: $TSFixMe,
) {
  return extractClientApplication(
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    await lcmApiClient(false).get(`/client_applications/${id}`, parameters),
  );
}

/* istanbul ignore next */
export async function patchClientApplication(
  id: $TSFixMe,
  clientApplication: $TSFixMe,
) {
  const { name, description } = clientApplication;
  const redirectURIs = clientApplication.redirectURIs.trim().split("\n");
  return lcmApiClient().patch(`/client_applications/${id}`, {
    name,
    description,
    redirect_uris: redirectURIs,
  });
}

/* istanbul ignore next */
export async function loadClientApplicationAccessRights(id: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get("/users/current/access_rights", {
    permitable_type: "ClientApplication",
    permitable_id: id,
  });
  return {
    canRead: (response as $TSFixMe).can_read,
    canUpdate: (response as $TSFixMe).can_update,
    canDelete: (response as $TSFixMe).can_delete,
    canPermit: (response as $TSFixMe).can_permit,
  };
}
